import React from 'react';

const LayoutFooter = () => (
  <footer className="bg-gray-900 text-gray-300 py-4 border-t border-gray-700 text-center text-xs md:text-sm">
    <p>&copy; 2025 Tigo. Todos los derechos reservados.</p>
  </footer>
);

export default LayoutFooter;
